import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from 'components/Grid';
import { Image } from 'components/Image';
import { Link } from 'components/Link';
import { cx, capitalizeFirstLetter } from 'utility';
import * as styles from './LogoList.module.scss';

const propTypes = {
    className: PropTypes.string,
    items: PropTypes.array,
    itemsPerRow: PropTypes.string,
};

const defaultProps = {
    className: '',
    items: [],
    itemsPerRow: 'auto',
};

function getClasses({ className, itemsPerRow }) {
    const classes = cx(
        className,
        styles['logoList'],
        styles[`logoList${itemsPerRow}`],
    );

    return classes || undefined;
}

function getLogoItemClasses({ logoSize, logoSizeMobile }) {
    const classes = cx(
        styles['item'],
        styles[`item${capitalizeFirstLetter(logoSize)}`],
        styles[`itemMobile${capitalizeFirstLetter(logoSizeMobile)}`],
    );

    return classes || undefined;
}

function LogoList({
    className,
    items,
    itemsPerRow,
}) {
    const classes = getClasses({ className, itemsPerRow });

    return (
        <div className={classes}>
            <Grid>
                <ul className={styles['container']}>
                    {items.map(({ logo_image, logo_link, logo_size, logo_size_mobile }, index) => {
                        const image = logo_image;
                        const logoLink = logo_link;
                        const logoSize = logo_size?.text;
                        const logoSizeMobile = logo_size_mobile?.text ? logo_size_mobile?.text : '';
                        const itemClasses = getLogoItemClasses({ logoSize, logoSizeMobile });

                        return (
                            <li className={itemClasses} key={`logo-list-item-${index}`}>
                                {(image?.url && !logo_link?.url && !logo_link?.uid) && (
                                    <Image
                                        className={styles['image']}
                                        image={image}
                                        size="xsmall"
                                    />
                                )}
                                {(image?.url && logo_link?.url || logo_link?.uid) && (
                                    <Link aria-label={image.alt} className={styles['link']} showExternalIcon={false} to={logoLink}>
                                        <Image
                                            className={styles['image']}
                                            image={image}
                                            size="xsmall"
                                        />
                                    </Link>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </Grid>
        </div>
    );
}

LogoList.propTypes = propTypes;
LogoList.defaultProps = defaultProps;

export { LogoList };
